import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import ArrowRight from '../../assets/icons/arrow-right-red.svg';
import { Wrapper, Col, Row, Container } from '../../components/layout';
import { PrimaryButton, OutlineButtonIcon } from '../../components/buttons';
import { Link, useHistory } from 'react-router-dom';
import { PlayerLastName, PlayerFirstName } from '../../components/text';
import { SelectInput } from '../../components/input';
import LoadingIndicator from '../../components/loading';
// import { useMediaQuery } from 'react-responsive';
// import { mobileBreakpoint } from '../../lib';
import { getReportsByYear, deleteItem } from '../../actions/api';
import { Td } from '../../components/table';
import { SocialMediaList } from '../../components';
import { DeleteItemModal } from '../../components/modal';
import { NoConfirmationExitHeader } from '../../components/actionHeader';

const yearOptions = ['2025','2024','2023','2022','2021','2020','2019','2018','2017','2016','2015','2014','2013','2012','2011','2010',
                     '2009','2008'];

const Report = styled(Row)`
    background-color: ${props => props.altRow ? '#161718' : '#000000'};
    border-top: ${props => props.firstRow ? '3px solid #d6001c' : ''};
    height: 52px;
    margin-bottom: 10px;
    align-items: center;
    flex-wrap: nowrap;
    position: relative;
`;

const PostStatusPill = styled.div`
    visibility: ${props => props.status === 'draft' ? 'hidden' : 'visible'};
    background-color: ${props => props.status === 'publish' ? '#d6001c' : 'transparent'};
    border: ${props => props.status === 'publish' ? '1px solid transparent' : '1px solid #FFFFFF' };
    color: #FFFFFF;
    font-weight: 700;
    font-size: 14px;
    font-family: 'Roboto Condensed', 'sans-serif';
    text-transform: uppercase;
    text-align: center;
    text-align: center;
    width: 75%;
    margin: 0 auto;
    padding: 7px;
    border-radius: 15px;
`;

const MyWrapper = styled(Wrapper)`
    padding-top: 0;
`

function SavedReport({ report, position, setSelectedId }){
    // const isTablet = useMediaQuery({minWidth: 1090});
    // const isMobile = useMediaQuery({maxWidth: mobileBreakpoint});
    const altRow = position % 2 !== 0;
    const nameSplit = report.data.player_name.split(' ');
    const firstName = nameSplit[0];
    const lastName = nameSplit[1];
    let date = new Date(`${report.date} 00:00`);
    date = date.toLocaleString('en-us', {month: 'short', day: 'numeric', year: 'numeric'});
    const parsedDate = date.split(' ');
    let title = report.title.replace(/\b\w/g, l => l.toUpperCase());
    if(title.length >= 35) title = title.substr(0,75) + '...';

    return (
        <Report altRow={altRow} firstRow={position === 0}>
            <Td width="5%">
                <svg style={{display: 'flex', margin: '0 auto', cursor: 'pointer'}} width="25px" height="25px" viewBox="0 0 35 35" version="1.1" onClick={setSelectedId}>
                    <g id="Icon/close/2px">
                        <path d="M19.0909 0L0 19.0909L19.0909 0Z" transform="translate(7.954545 7.954545)" id="Path-3-Copy-4" fill="none" stroke="#d6001c" strokeWidth="2" />
                        <path d="M19.0909 19.0909L0 0L19.0909 19.0909Z" transform="translate(7.954545 7.954545)" id="Path-3-Copy-5" fill="none" stroke="#d6001c" strokeWidth="2" />
                    </g>
                </svg>
            </Td>
            <Td width="10%">
                {`${parsedDate[0]} ${parsedDate[1].split(',')[0]}/${parsedDate[2].substr(2,2)}`}
            </Td>
            <Td width={'20%'}>
                <PlayerLastName>{lastName}</PlayerLastName>
                <PlayerFirstName>{firstName}</PlayerFirstName>
            </Td>

            <Td width='25%'><b>{title}</b></Td>

            <Td width='10%'><b>{report.data.league}</b></Td>

            <Td width="19%" style={{ visibility: report.status !== 'publish' && 'hidden' }}>
                <SocialMediaList postId={report.permalink} type="reports"/>
            </Td>

            <Td width="13%">
                <PostStatusPill status={report.status}>{report.status === 'publish' ? 'published' : 'pending'}</PostStatusPill>
            </Td>

            <Td width="15%" style={{display: 'flex', justifyContent: 'center'}}>
                {report.status === 'draft' ?
                    <Link to={`/reports-builder/${report.id}`} >
                        <OutlineButtonIcon background={altRow ? '#161718' : '#000000'} marginLeftIcon="5px" icon={ArrowRight}>
                            {report.status === 'draft' ? 'Edit' : 'View'} {report.data.event === 'Summary' ? report.data.event : 'Report'}
                        </OutlineButtonIcon>
                    </Link> :
                <a href={report.permalink}>
                    <OutlineButtonIcon background={altRow ? '#161718' : '#000000'} marginLeftIcon="5px" icon={ArrowRight}>
                        {report.status === 'draft' ? 'Edit' : 'View'} {report.data.event === 'Summary' ? report.data.event : 'Report'}
                    </OutlineButtonIcon>
                </a>}
            </Td>
        </Report>
    );
}

function SavedReports(){

    let history = useHistory();

    const [ yearFilter, setYearFilter ] = useState('2025');
    const [ loading, setLoading ] = useState(false);
    const [ isDeleteModalOpen, setIsDeleteModalOpen ] = useState(false);
    const [ selectedId, setSelectedId ] = useState('');
    const [ deletedIds, setDeletedIds ] = useState([]);
    const [ deleting, setDeleting ] = useState(false);
    const [ reports, setReports ] = useState([]);

    document.title = "Saved Reports - FCHockey";
    
    useEffect(() => {
        const fetchReportsByYear = async() => {
            try{
                setLoading(true);
                const reports = await getReportsByYear(yearFilter);
                setReports(reports);
                setLoading(false);
            }
            catch(error){
                console.log(error);
                setLoading(false);
            }
        }
        fetchReportsByYear();
    }, [yearFilter]);

    const handleDelete =  async() => {
        setDeleting(true);
        const res = await deleteItem(selectedId, 'reports');
        setDeleting(false);
        setIsDeleteModalOpen(false);
        setDeletedIds([...deletedIds, res.previous.id]);
    }
    useEffect(() => {
        if(selectedId) setIsDeleteModalOpen(true);
    }, [ selectedId ]);
    useEffect(() => {
        if(selectedId && !isDeleteModalOpen) setSelectedId('');
    }, [ selectedId, isDeleteModalOpen ]);

    return (
        <MyWrapper>
            <DeleteItemModal
                item="reports"
                handleModalOpen={setIsDeleteModalOpen}
                isOpen={isDeleteModalOpen}
                handleDeleteItem={handleDelete}
                disabled={deleting}
            />
            <NoConfirmationExitHeader />
            <Row justifyContent="space-between" alignItems="center" margin="0 0 20px 0">
                <Col>
                    <h1>My reports</h1>
                </Col>
                <Col>
                    <Link to="/reports-builder">
                        <PrimaryButton onClick={() => history.push('/reports-builder')}>Create a report</PrimaryButton>
                    </Link>
                </Col>
            </Row>
            <Row margin="0 0 35px 0">
                <SelectInput
                    value={yearFilter}
                    onChange={(e) => setYearFilter(e.target.value)}
                    options={yearOptions.map((opt)=>({label:opt,value:opt}))}
                    inputPadding="0 43px 0 0"
                    width="150px"
                />
            </Row>
            { loading ? <LoadingIndicator /> : <Container>
                {reports
                    .filter((d) => !deletedIds.some((x) => x === d.id))
                    .sort((a, b) => new Date(b.date) - new Date(a.date))
                    .map((report, id)=> <SavedReport report={report} key={report.id} position={id} setSelectedId={()=>setSelectedId(report.id)}/>)}
            </Container> }
        </MyWrapper>
    )
}
export default SavedReports;